import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c0dc52be&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dc52be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0dc52be')) {
      api.createRecord('c0dc52be', component.options)
    } else {
      api.reload('c0dc52be', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c0dc52be&scoped=true&", function () {
      api.rerender('c0dc52be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WsokFfcD8Mlz/JS/comp/Accordion.vue"
export default component.exports